export const manifestBase = {
  short_name: 'Yalo Sales Desk',
  name: 'Yalo Sales Desk',
  icons: [
    {
      src: 'favicon.ico',
      sizes: '64x64 32x32 24x24 16x16',
      type: 'image/x-icon',
    },
    {
      src: 'icon-tab.png',
      type: 'image/png',
      sizes: '100x100',
    },
  ],
  display: 'standalone',
  theme_color: '#ffffff',
  background_color: '#ffffff',
};
